module.exports = __webpack_public_path__ + "media/images/icons/step-icon-orange-empty-dcb7d378623713af0c0d6e8b9ee488ab.svg";